
































































import {Component, Prop, Vue, Watch} from 'vue-property-decorator'
import { getLocalStorage } from '../../../store/src/utils/index'
import verifyCode from './VerifyCode.vue'
@Component({
	components: {
		verifyCode
	}
})
export default class VerifyCodes extends Vue {
	@Prop ({
		type: String,
		required: true,
		default: ''
	}) private title!: string
	@Prop ({
		type: String,
		required: false,
		default: ''
	}) private name!: string
	@Prop() private beforeClick!: any
	private names: string = ''
	private code: string = ''
	private newPassword: any = ''
	private newPasswordConfirm: any = ''
	private type: number = 2
	private verifyImgCode: string = ''
	private uuid: string = (this as any).$fxUtils.createUUID()
	private verifyCodeImgUrl: string = ''
	private created () {
		this.initData()
	}
	private initData () {
		this.initPassword()
	}
	private initPassword () {
		this.names = this.name.substr(0, 3) + '******' + this.name.substr(-3, 3)
	}
	private beforeVerifyCodeClick () {
		return new Promise ((resolve: any) => {
			this.validateVerifyImgCode(this.verifyImgCode).then(() => {
				this.$emit('on-vaildate-mobile', this.name, resolve)
			})
		})
	}
	private onConfirmClick () {
		this.beforePasswordHandle()
	}
	private vaildateCode (value: any) {
		return new Promise ((resolve: any) => {
			if (!value) {
				(this as any).$fxMessage.error('验证码不能为空')
				return false
			} else if (!(this as any).$fxUtils.regVerifyCode().test(value)) {
				(this as any).$fxMessage.error('验证码为四位数字')
				return false
			} else {
				resolve()
			}
		})
	}
	private validateVerifyImgCode (value: any) {
		return new Promise ((resolve: any) => {
			if (!value) {
				(this as any).$fxMessage.error('图形验证码不能为空')
				return false
			} else {
				resolve()
			}
		})
	}
	@Watch('uuid', { immediate: true })
	private onUuidChange (val: any, oldVal: any) {
		this.verifyCodeImgUrl = `/cldEdi/business/${val}/getVerifyCode`
	}
	private refreshVerifyImgCode () {
		this.uuid = (this as any).$fxUtils.createUUID()
		const verifyImgCode = (this as any).$refs.verifyImgCode
		verifyImgCode.select()
	}
	private beforePasswordHandle () {
		this.vaildateCode(this.code).then(() => {
			this.$emit('on-modify-pass', this.newPassword, this.newPasswordConfirm, this.code, this.uuid, this.verifyImgCode)
		})
	}
	private destoryCode (name) {
		this.newPassword = ''
		this.newPasswordConfirm = ''
		this.code = ''
	}
}
